/** Format a picker date without shifting its calendar day through UTC. */
export const formatPaymentDate = date =>
	`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`

/** Parse a calendar day, rejecting malformed dates instead of rolling them over. */
const calendarDate = value => {
	if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}(?:$|[T ])/.test(value)) return null
	const [year, month, day] = value.slice(0, 10).split("-").map(Number)
	const date = new Date(year, month - 1, day)
	return formatPaymentDate(date) === value.slice(0, 10) ? date : null
}

/** Normalize old and new API offsets; unavailable values disable extension. */
export const normalizePaymentOffset = value => {
	// Also accept the old event-specific response during a staggered deployment.
	const raw = value && typeof value === "object" ? value.value : value
	if (typeof raw !== "number" && (typeof raw !== "string" || !/^\d+$/.test(raw))) return null
	const offset = Number(raw)
	return Number.isSafeInteger(offset) && offset >= 0 ? offset : null
}

/** Add calendar days across month and daylight-saving boundaries. */
const addDays = (date, days) => {
	const result = new Date(date)
	result.setDate(result.getDate() + days)
	return result
}

/** Return the inclusive patron window, or null when no extension is available. */
export const paymentExtensionWindow = ({ originalDate, scheduledDate, eventStart, offset, paymentStatusId, today, patronExtensionUsed }) => {
	if (![1, 11].includes(paymentStatusId)) return null
	const original = calendarDate(originalDate || scheduledDate)
	const scheduled = calendarDate(scheduledDate)
	const event = calendarDate(eventStart)
	const current = calendarDate(today)
	const daysBeforeEvent = normalizePaymentOffset(offset)
	if (!original || !scheduled || !event || !current || daysBeforeEvent === null) return null
	if (patronExtensionUsed) return null
	const min = addDays(original > current ? original : current, 1)
	const max = new Date(Math.min(+addDays(original, 30), +addDays(event, -daysBeforeEvent)))
	return Number.isFinite(+max) && min <= max ? { min, max } : null
}
